/* Libraries */
import React from 'react';

/* Hooks */
import useTemplatesActions from '~/src/hooks/useTemplatesActions';

/* Components */
import { TemplatesWrapper } from '~/src/components/Templates';
import { Template } from '~/src/components/Templates/TemplatesWrapper';
import { TemplateSource } from '../types/template';

const TemplatesContainer = ({
  onPreviewTemplate,
  source = TemplateSource.FIRM,
  enableClioWorkCopy = false,
}: {
  onPreviewTemplate?: (t: Template) => void;
  source?: TemplateSource;
  enableClioWorkCopy?: boolean;
}) => {
  const {
    previewTemplate: handlePreviewTemplate,
    renameTemplate: handleRenameTemplate,
    deleteTemplate: handleDeleteTemplate,
    addTemplateToSeletionSidebar: handleAddTemplateToSeletionSidebar,
  } = useTemplatesActions();

  const rowActions = {
    rename: handleRenameTemplate,
    preview: handlePreviewTemplate,
    delete: handleDeleteTemplate,
  };

  return (
    <TemplatesWrapper
      addTemplateToSeletionSidebar={handleAddTemplateToSeletionSidebar}
      rowActions={rowActions}
      onPreviewTemplate={onPreviewTemplate}
      source={source}
      enableClioWorkCopy={enableClioWorkCopy}
    />
  );
};

export default TemplatesContainer;
